import React from "react";
import { Redirect } from "react-router-dom";

export default function LaunchToSetting() {
  return <Redirect to="/db/setting/business" />;
}
